<template>
  <div class="row mt-4">
    <div class="col-12">
      <material-input
        id="title"
        v-model="titleHandler"
        is-required
        variant="static"
        label="Titel"
        placeholder="Vul een titel in"
      />
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-12">
      <material-textarea
        id="description"
        v-model="descriptionHandler"
        variant="static"
        label="Omschrijving"
        placeholder="Vul een omschrijving in"
        :rows="3"
      />
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-12">
      <material-input
        id="url"
        v-model="urlHandler"
        variant="static"
        label="Website"
        placeholder="Vul een website in"
        type="url"
      />
    </div>
  </div>

  <material-button
    v-if="showUpdate"
    class="float-end mt-6 mb-0"
    color="dark"
    variant="gradient"
    size="sm"
  >
    Update gegevens
  </material-button>
</template>

<script>
import { createVModelHandlers } from '@/helpers/vue';
import MaterialButton from '@/components/MaterialButton.vue';
import MaterialInput from '@/components/MaterialInput.vue';
import MaterialTextarea from '@/components/MaterialTextarea.vue';

export default {
  name: 'BasicInfo',

  components: {
    MaterialButton,
    MaterialInput,
    MaterialTextarea,
  },

  props: {
    description: {
      type: String,
      required: true,
    },
    showUpdate: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
  },

  emits: [
    'update:description',
    'update:title',
    'update:url',
  ],

  computed: {
    ...createVModelHandlers(
      'description',
      'title',
      'url',
    ),
  },
};
</script>